import type { ChipProps } from '@mui/material'
import { Chip } from '@mui/material'

const GridChipCell = ({ sx, ...props }: ChipProps) => {
  return <Chip {...props} sx={{ ...sx, m: 0.2, cursor: 'inherit' }} />
}

export default GridChipCell
